import './Migrate.scss';
import React, { Component } from 'react';
import { getAccountFromChatbot, getWhatsapSettings, migrateWhatsAppSettings } from 'services/CeberusApiService';
import { Layout, Card, Icon, Input, List, Button, Popconfirm } from 'antd';
import { TenantService } from 'connection/TenantService';
import { BaseRequest, MigrateWhatsAppRequest, OverviewRequest } from 'models/request/Index';
import { PushNotification } from 'utils/PushNotification';
import { GridView } from 'models/GridView';
import { Tenant } from 'models/Blip/Index';

const { Search } = Input;
const ListItem = List.Item;
const ListItemMeta = List.Item.Meta;
const POPUP_CONTENT = 'Are you sure you want to migrate to this bot?';
const IDENTITY = 'identity';

export class Migrate extends Component<BaseRequest> {
  
  tenantSelected: Tenant;
  
  state = {
    isLoading: false,
    destinationIdentity: null,
    destinationInformation: [],
    currentApplication: {},
    currentApplicationInformation: [],
    isButtonDisabled: true,
    isButtonSearchLoading: false,
    isButtonMigrateLoading: false,
    hasWhatsapp: false,
    whatsAppConfiguration: { 
      WebAppHostName : null,
      Password: null
    }
  };

  async componentDidMount() {
    this.tenantSelected = TenantService.getSelectedTenant();
    await this.onBuild();
  }
  
  cloneBot = async () => {
    if (!this.state.destinationIdentity) {
      PushNotification.error('Chatbot not found!');
      return;
    }

    try {
      this.setState({ 
        isLoading: true,
        isButtonMigrateLoading: true
      });
      const identifier = this.props.BotIdentifier.split('@')[0];
      const destinationIdentity = this.state.destinationIdentity;
      const response = await migrateWhatsAppSettings(new MigrateWhatsAppRequest(destinationIdentity, identifier, this.tenantSelected.name))
      PushNotification.success(response);
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setState({ 
        isLoading: false,
        isButtonMigrateLoading: false 
      });
    }
  }

  onBuild = async () : Promise<void> => {
    try {
      this.setState({ isLoading: true });
      const waConfig = await getWhatsapSettings(new MigrateWhatsAppRequest('', this.props.BotIdentifier, this.tenantSelected.name));
      this.setState({
        whatsAppConfiguration : waConfig,
        isLoading: false,
        hasWhatsapp: true,
        currentApplicationInformation: this.getConfigurationExhibition(
          { 
            identity: this.props.BotIdentifier,
            ...waConfig
          }
        )
      });
    } catch (error) {
      PushNotification.warnig(error.response.data);
      this.setState({ isLoading: false, hasWhatsapp: false });
    }
  }

  getConfigurationExhibition = (botConfig: any) : Array<GridView> => {
    if(!botConfig){
      return [];
    }

    return Object.keys(botConfig).map((key) => {
      const configDescription = this.getConfigDescription(botConfig, key);
      return {
        title: `${key}:`,
        description: configDescription,
      }
    });
  }

  getDestinationlist = (currentApplication: any) : Array<GridView> => {
    if (currentApplication) {
      return [
        {
          title: `${IDENTITY}:`,
          description: this.getConfigDescription(currentApplication, IDENTITY)
        }
      ]
    }
  }

  getConfigDescription = (botConfig: any, key: string) : string => {
    return botConfig[key] != undefined
      ? botConfig[key].split('@')[0]
      : '';
  }

  onSearch = async (identifier: string) : Promise<void> => {
    if (!identifier) {
      this.setState({
        destinationInformation: [],
        destinationIdentity: null,
        isButtonDisabled: true,
        isButtonSearchLoading: false
      });
      return;
    }
   
    try {
      this.setState({ 
        isLoading: true,
        isButtonSearchLoading: true
      });

      const request = new OverviewRequest();
      request.BotIdentifier = identifier;
      request.ClusterName = this.tenantSelected.name;
      const account = await getAccountFromChatbot(request);
      
      this.setState({
        currentApplication:
          {
            id: identifier,
            identity: `${account.identity.Name}@${account.identity.Domain}`,
            fullName: account.fullName
          },
      });

      this.setState({
        isButtonDisabled: false,
        destinationIdentity: identifier,
        destinationInformation : this.getDestinationlist(this.state.currentApplication)
      });

    } catch (error) {
      PushNotification.error(error);
      this.setState({
        destinationInformation: [],
        destinationIdentity: null,
        isButtonDisabled: true
      });
    } finally {
      this.setState({ 
        isLoading: false,
        isButtonSearchLoading: false
      });
    }
  }

  render() {
    return (
      <>
        <div style={{ display: this.state.hasWhatsapp ? 'block' : 'none' }}>
          <div className="flex flex-column search">
            <h1>
              <Icon type="import" className="mr3" />
              Migrate Bot
            </h1>
            <Search
              placeholder="Destination Bot"
              enterButton="Search"
              size="large"
              onSearch={this.onSearch}
              className="w-50"
              loading={this.state.isButtonSearchLoading}
            />
          </div>
          <div className="flex flex-column cards">
            <div className="w-70">
              <Layout.Content className="flex justify-between">
                <Card title="Origin Information" className="w-40" size="small">
                  <List
                    loading={this.state.isLoading}
                    itemLayout="horizontal"
                    dataSource={this.state.currentApplicationInformation}
                    renderItem={item => !item.invisible ? (
                      <ListItem actions={item.actions}>
                        <ListItemMeta
                          title={item.title}
                          description={(<p style={{ overflowWrap: 'break-word', width: 400 }}>
                            {item.description}
                          </p>)}>
                        </ListItemMeta>
                      </ListItem>
                    ) : <></>}>
                  </List>
                </Card>
                <Card title="Destination Information" className="w-40" size="small">
                  <List
                    loading={this.state.isLoading}
                    itemLayout="horizontal"
                    dataSource={this.state.destinationInformation}
                    renderItem={item => !item.invisible ? (
                      <ListItem actions={item.actions}>
                        <ListItemMeta
                          title={item.title}
                          description={item.description}>
                        </ListItemMeta>
                      </ListItem>
                    ) : <></>}>
                  </List>
                </Card>
                <div className="flex flex-column switchs">
                  <div className="tl">
                  </div>
                  <div className="clone-button">
                    <Popconfirm disabled={this.state.isButtonDisabled} placement="top" title={POPUP_CONTENT} onConfirm={this.cloneBot} okText="Clone" cancelText="Cancel">
                      <Button 
                        disabled={this.state.isButtonDisabled} 
                        loading={this.state.isButtonMigrateLoading}
                        className='tc' 
                        size='large' 
                        type='primary'>
                        Migrate
                        <Icon type="import" />
                      </Button>
                    </Popconfirm>
                  </div>
                </div>
              </Layout.Content>
            </div>
          </div>
        </div>
      </>
    )
  }
}